import { useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchCoursesRequest, resetCoursesFailure } from '../../actions/fetchCoursesActions';
import {
  coursesSelector,
  fetchCoursesLoadingSelector,
  fetchCoursesErrorSelector,
  selectedSchoolSelector,
  selectedCourseSelector,
  campusSelector,
} from '../../reducers/selectors';

const useCourses = () => {
  const [reload, setReload] = useState(0);
  const dispatch = useDispatch();
  const selectedSchool = useSelector(selectedSchoolSelector);
  const allCourses = useSelector(coursesSelector);
  const isLoading = useSelector(fetchCoursesLoadingSelector);
  const error = useSelector(fetchCoursesErrorSelector);
  const selectedCourse = useSelector(selectedCourseSelector);
  const selectedCampus = useSelector(campusSelector);

  useLayoutEffect(() => {
    if (
      !error &&
      !isLoading &&
      selectedSchool &&
      !allCourses[selectedSchool.value] &&
      selectedCampus &&
      selectedCampus.value
    ) {
      dispatch(fetchCoursesRequest(selectedSchool.value));
    }
  }, [dispatch, allCourses, error, isLoading, selectedSchool, selectedCampus]);

  const reset = id => {
    dispatch(resetCoursesFailure());
    setReload(reload + 1);
  };

  return {
    data: selectedSchool ? allCourses[selectedSchool.value] || [] : [],
    allCourses,
    isLoading,
    error,
    reload: () => reset(),
    retries: reload,
    selectedCourse,
    beforeStep: selectedSchool,
  };
};

export default useCourses;
